import { FormInput, Modal, notify } from "@general-backoffice/core";
import FormInputTooltipLabel from "@general-backoffice/core/lib/form/utils/FormInputTooltipLabel";
// import { userPaymentMethodsRequests } from "../../api/requests";
// import { notifyLoadingToError, notifyLoadingToSuccess } from "../utils/notify/notifyLoadingUpdate";
// import { getManagers } from "../managers/hooks/useManagers";
// import useTranslatedPaymentMethodTypes from "../../hooks/translations/useTranslatedPaymentMethodTypes";
// import {useTranslation} from "react-i18next";
import RevolutCheckout, { type RevolutCheckoutCardField } from "@revolut/checkout";
import React, { type ChangeEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup } from "reactstrap";

import { paymentMethodsEndpoints } from "../../api";
import getErrorMessage from "../../utils/getErrorMessage";
import { notifyLoadingToError, notifyLoadingToSuccess } from "../../utils/notify/notifyLoadingUpdate";
import config from "./../../config/configuration";

// Local type definitions
interface CreateUserPaymentMethodModalProps {
  isOpen: boolean;
  close: () => void;
  onCreated?: (pm?: unknown) => void;
}

interface PaymentMethodOption {
  label: string;
  value: string;
  icon: string;
}

let notification: string | number | undefined;

const CreateUserPaymentMethodModal: React.FC<CreateUserPaymentMethodModalProps> = ({ isOpen, close, onCreated }) => {
  const { t } = useTranslation("paymentMethods", { keyPrefix: "createUserPaymentMethodModal" });
  const cardField = useRef<HTMLDivElement>(null);
  const [name, setName] = useState<string>("");
  const [card, setCard] = useState<RevolutCheckoutCardField | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  // Keep the latest onCreated without making it an effect dependency — otherwise a
  // parent passing an inline callback re-runs the effect on every render, creating a
  // new Revolut order and appending a duplicate card field into the same container.
  const onCreatedRef = useRef(onCreated);
  onCreatedRef.current = onCreated;

  const pmOptions: PaymentMethodOption[] = [
    { label: "Card", value: "card", icon: "fas fa-credit-card" },
    // { label: "Sepa", value: 'sepa', icon: 'fas fa-university' }
  ];
  const [setectedOption] = useState<PaymentMethodOption>(pmOptions[0]);
  const { value: pmType } = setectedOption;

  useEffect(() => {
    if (!isOpen) setName("");
    else {
      setLoading(true);
      paymentMethodsEndpoints
        .getRevolutPaymentMethodToken()
        .then(({ data: tokenData }) => {
          const token = tokenData?.token || "";
          const orderId = tokenData?.orderId || "";
          const revolutEnv = config.revolut_env === "prod" ? "prod" : "sandbox";
          void RevolutCheckout(token, revolutEnv).then((instance) => {
            if (typeof instance.createCardField !== "function" || !cardField.current) return;
            setCard(
              instance.createCardField({
                target: cardField.current,
                locale: "es",
                onSuccess() {
                  paymentMethodsEndpoints
                    .confirmRevolutPaymentMethodCreation(orderId)
                    .then(({ data: pm }) => {
                      onCreatedRef.current?.(pm);
                      notifyLoadingToSuccess(notification, t("warnings.paymentMethodCreationSuccess"));
                    })
                    .catch((err: unknown) => {
                      onCreatedRef.current?.();
                      notifyLoadingToError(
                        notification,
                        getErrorMessage(err, t("warnings.paymentMethodCreationError"))
                      );
                    });
                },
                onError(err: unknown) {
                  notifyLoadingToError(notification, getErrorMessage(err, t("warnings.paymentMethodCreationError")));
                },
              })
            );
          });
        })
        .finally(() => setLoading(false));
    }
    // Intentionally excludes `onCreated`/`t` (read via ref/closure at call time) so the
    // card field is created once per open, not re-created on every parent render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, pmType]);

  const handleSubmit = async () => {
    if (!card) return;
    setLoading(true);
    notification = notify.loading(t("warnings.paymentMethodCreationLoading"));
    try {
      switch (pmType) {
        case "card":
          await createCard();
          break;
        case "sepa":
          // pmId = await createSEPA();
          break;
        default:
          throw new Error("Por favor, seleccione una forma de pago válida");
      }
    } catch (err: unknown) {
      notifyLoadingToError(notification, getErrorMessage(err, t("warnings.paymentMethodCreationError")));
    } finally {
      setLoading(false);
    }
  };

  const createCard = () => card?.submit({ name, savePaymentMethodFor: "merchant" });

  return (
    <Modal.FormContainer
      isOpen={isOpen}
      toggleOpen={close}
      // title="Add payment method"
      title={t("title")}
      closeText={t("closeBtn")}
      onSubmit={handleSubmit}
      buttonSave={{
        children: t("submitBtn"),
        disabled: isLoading || pmType !== "card",
      }}
      isLoading={isLoading}
    >
      {/*<FormInput.Select*/}
      {/*  icon={icon && <i className={`${icon} px-2`}/>}*/}
      {/*  onChange={setSelectedOption}*/}
      {/*  options={pmOptions}*/}
      {/*  value={setectedOption}*/}
      {/*  isDisabled={isLoading}*/}
      {/*/>*/}

      {/*<FormDecoration.Line/>*/}

      {pmType === "card" ? (
        <>
          <FormInput.Input
            type="text"
            onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
            value={name}
            name="name"
            // label={t("companyNameLabel")}
            label={t("form.name") + " *"}
            disabled={isLoading}
            required
          />
          <FormGroup>
            <FormInputTooltipLabel>{t("form.card")} *</FormInputTooltipLabel>
            <div ref={cardField} className="form-control" />
          </FormGroup>
        </>
      ) : (
        <p>{t("warnings.invalidPaymentMethodType")}</p>
      )}
    </Modal.FormContainer>
  );
};

export default CreateUserPaymentMethodModal;
